import { HEADER_HEIGHT, HEADER_HEIGHT_MOBILE } from 'constants/components';
import { useBreakpointFlags } from 'hooks/useBreakpointFlags';

export const useHeaderHeight = () => {
  const { isLgUp: isDesktop } = useBreakpointFlags();
  const headerHeight = isDesktop ? HEADER_HEIGHT : HEADER_HEIGHT_MOBILE;

  return { headerHeight };
};
